import EntityInterface from '../../common/types/entities/EntityInterface'
import createEntitySettings from '../components/core/Sidebar/components/Settings/entities'

export default function createCommonEntitySettings(
  entity: EntityInterface,
  defaultEntity?: EntityInterface,
) {
  return createEntitySettings(entity, defaultEntity)
}
